import { Component, Input } from '@angular/core';
import { PlayerService } from '../library/player.service';
import { ControlService } from '../library/control.service';
import { AmplitudeService } from 'src/app/services/external-tools/amplitude.service';
import { AmplitudeTrackingEvents } from 'src/app/utils/enums/amplitude/amplitudeTrackingEvents.enum';
import { CallStoreService } from '../library/call-store/call-store.service';
@Component({
  selector: 'app-pre-call',
  templateUrl: './pre-call.component.html',
  styleUrls: ['./pre-call.component.scss'],
  standalone: false
})
export class PreCallComponent {
  @Input() playerService: PlayerService | undefined;
  @Input() controlService: ControlService | undefined;

  constructor(
    private amplitudeService: AmplitudeService,
    public callStore: CallStoreService
  ) {}
  public sendAmplitudeClickPauseEvent(): void {
    // Sending the Event of Clicking on Pause
    this.amplitudeService.trackEvent(AmplitudeTrackingEvents.CALL_CLICK_PAUSE, {
      'call_type': this.controlService?.callType,
    });
  }

  public handlePreCallPauseClick(): void {
    this.sendAmplitudeClickPauseEvent();
    this.controlService?.togglePause();
  }

}
